import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class BilRequirementService {

  constructor(private http: HttpClient) { }

  /**
   * @method createBusinessRequest
   * @description Deciding for request method post and put based on bil id
   * @param {Object} reqBody
   * @return void
   */
  createBusinessRequest(reqBody) {
    let bil_id = localStorage.getItem('X-BIL-ID');
    let urlString;
    if(localStorage.getItem('isPayLater')) {
      urlString = '/pl/create-business-request';
    } else {
      urlString = '/create-business-request';
    }
    if (bil_id) {
      delete reqBody['panGst'];
      delete reqBody['source'];
      return this.http.put(environment.basePath + urlString, reqBody);
    } else {
      return this.http.post(environment.basePath + urlString, reqBody);
    }
  }

  industrySearch(reqBody) {
    return this.http.post(environment.basePath + '/industry/search', reqBody);
  }

  pangstValidation(requestBody) {
    return this.http.post(environment.basePath + '/pan/verifyPanGst/isValid', requestBody);
  }

  getRequirementDetails(bil_id) {
    return this.http.get(environment.basePath + '/requirement/lead');
  }
}
